import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-OrthogonalAxisNetwork",
  "use": "icon-OrthogonalAxisNetwork-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-OrthogonalAxisNetwork\"><path d=\"M971.776 665.088v76.8H741.888v229.888h-76.8V741.888H332.8V972.8H256V741.888H50.688v-76.8H256v-281.6H50.688v-76.8H256V51.2h76.8v255.488h332.288v-256h76.8v256h229.888v76.8H741.888v281.6h229.888zm-306.688-281.6H332.8v281.6h332.288v-281.6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol